import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import AdsCard from '@components/AdsCard';
import CommunityActions from '~/actions/community';
import CompanyActions from '~/actions/company';
import VendorActions from '~/actions/vendor';
import { convertUrl } from '~/services/util';
import Card from './Card.jsx';

const CommunityBlogs = ({ data, title, adsList, loading }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.app.user?.community_user);
    const [adsIdx, setAdsIdx] = useState(Math.round(Math.random() * adsList.length));

    useEffect(() => {
        const content_id = data.map((x) => x.id);
        const payload = {
            data: {
                community_user_id: user?.id,
                events: [{ content_id, source: 'home', type: 'impression' }],
            },
        };
        dispatch(CommunityActions.addcontenteventRequest(payload, loading));
    }, []);

    useEffect(() => {
        setAdsIdx(Math.round(Math.random() * adsList.length));
    }, [adsList.length]);

    const handleClick = (e) => {
        const payload = {
            data: {
                community_user_id: user?.id,
                events: [{ content_id: e.id, source: 'home', type: 'click' }],
            },
        };
        dispatch(CommunityActions.addcontenteventRequest(payload, false));
        if (e.data?.blog_type === 'user') {
            dispatch(CommunityActions.getcommunityuserRequest({ userId: e.author.id, blogId: e.blog.id }, null, null, null, false));
            window.location = e?.data?.permalink;
        } else if (e.data?.blog_company_id) {
            dispatch(
                VendorActions.getvrcompanydetailRequest({
                    companyId: e.data.blog_company_id,
                    callback: handleCompanyCallback(e),
                })
            );
        }
    };

    const handleCompanyCallback = (post) => (e) => {
        if (e?.company?.business_id) {
            const payload = { id: e.company.business_id };
            const route = {
                pathname: post?.data?.permalink,
                state: { post },
            };
            dispatch(CompanyActions.getbusinessRequest(payload, route));
        }
    };

    const handleOpenProfile = (e) => () => {
        dispatch(CommunityActions.getcommunityuserRequest({ userId: e.author.id, blogId: e.blog.id }));
        window.location = `/${e.author.entity.slug}/about`; //?user_id=${e.author.id}`
    };

    const adsData = adsList[adsIdx];

    return (
        <div className="recent-blogs-feed">
            <p className="dsl-b18 bold blogs-title">{title}</p>
            {data.length > 0 ? (
                data.map((item, index) =>
                    adsData && index === 1 ? (
                        <AdsCard key={`ads-${index}`} className="mb-2" size="medium" data={adsData} />
                    ) : (
                        <Card
                            avatar={convertUrl(item.author_avatar)}
                            date={moment(item.created_at).format('MMM DD, YY')}
                            key={item.id}
                            images={item.data.body}
                            index={index}
                            stats={item.stats}
                            text={item.body_text}
                            title={item.name}
                            user={item.author}
                            company={item.blog.company}
                            appId={user?.id}
                            onClick={() => handleClick(item)}
                            onOpen={handleOpenProfile(item)}
                        />
                    )
                )
            ) : adsData ? (
                <AdsCard className="mb-2" size="medium" data={adsData} />
            ) : (
                <p className="dsl-m14 p-4 m-0 text-center bg-white">No posts to display.</p>
            )}
        </div>
    );
};

CommunityBlogs.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    adsList: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            img: PropTypes.string,
            img_small__300: PropTypes.string,
            img_medium__800: PropTypes.string,
            sponsor: PropTypes.string,
            url__target: PropTypes.string,
        })
    ),
};

CommunityBlogs.defaultProps = {
    adsList: [],
    data: [],
    title: '',
};

export default CommunityBlogs;
